import { render, staticRenderFns } from "./newsInfo.vue?vue&type=template&id=46be5c43&scoped=true&"
import script from "./newsInfo.vue?vue&type=script&lang=js&"
export * from "./newsInfo.vue?vue&type=script&lang=js&"
import style0 from "./newsInfo.vue?vue&type=style&index=0&id=46be5c43&prod&lang=scss&"
import style1 from "./newsInfo.vue?vue&type=style&index=1&id=46be5c43&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46be5c43",
  null
  
)

export default component.exports